import MarqueeTechnology from './MarqueeTechnology';

const Technology = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="section_space pb-0">
            <div className="">
                <div className="heading_block text-center">
                    <div className="heading_focus_text">
                        Our
                        <span className="badge bg-secondary text-white">Tech Stack</span>
                    </div>
                    <h2 className="heading_text mb-0">
                        Featured Tech Stack
                    </h2>
                </div>

                <MarqueeTechnology />
            </div>
        </section>
    );
}

export default Technology;